// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__xgjbP","approved":"Status_approved__2YOMo","rejected":"Status_rejected__tTANA","expired":"Status_expired__2oITo","label":"Status_label__vUWmD"};